import axios from 'axios';

const state = {
  cursos: [], // Lista de cursos
};

const mutations = {
  SET_CURSOS(state, cursos) {
    state.cursos = cursos;
  },
  ADD_CURSO(state, curso) {
    state.cursos.push(curso);
  },
  UPDATE_CURSO(state, curso) {
    const index = state.cursos.findIndex(c => c.id === curso.id);
    if (index !== -1) {
      state.cursos.splice(index, 1, curso);
    }
  },
  DELETE_CURSO(state, cursoId) {
    state.cursos = state.cursos.filter(curso => curso.id !== cursoId);
  },
};

const actions = {
  async fetchCursos({ commit }) {
    try {
      const response = await axios.get('/api/curso'); // Endpoint para obtener los cursos
      commit('SET_CURSOS', response.data);
    } catch (error) {
      console.error('Error fetching cursos:', error);
      throw error; // Lanzar error para manejarlo en el componente si es necesario
    }
  },
  async createCurso({ commit }, curso) {
    try {
      const response = await axios.post('/api/curso', curso); // Endpoint para crear un curso
      commit('ADD_CURSO', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating curso:', error);
      throw error;
    }
  },
  async updateCurso({ commit }, curso) {
    try {
      const response = await axios.put(`/api/curso/${curso.id}`, curso); // Endpoint para actualizar un curso
      commit('UPDATE_CURSO', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating curso:', error);
      throw error;
    }
  },
  async deleteCurso({ commit }, cursoId) {
    try {
      await axios.delete(`/api/curso/${cursoId}`); // Endpoint para eliminar un curso
      commit('DELETE_CURSO', cursoId);
    } catch (error) {
      console.error('Error deleting curso:', error);
      throw error;
    }
  },
};

const getters = {
  cursos: state => state.cursos, // Obtener la lista de cursos
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
